module.exports = __webpack_public_path__ + "img/6e9bb43.jpg";